import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useState } from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../../components/Button';
import NewEstimateComparison from '../forms/newEstimateComparison';

export type customNewEstimateTabProps = React.PropsWithoutRef<{
  handleOnSave?: any;
  isInline?: boolean;
  handleBackToResults?: any;
  handleFormsOfPayment?: any;
}>;

const NewEstimateTab = ({
  handleOnSave,
  handleBackToResults,
  handleFormsOfPayment,
  isInline = false,
}: customNewEstimateTabProps) => {
  const [secondScenario, setSecondScenario] = useState(false);
  const [showPaymentConfirmation, setShowPaymentConfirmation] = useState(false);

  const handleAddScenario = () => {
    setSecondScenario(true);
    if (showPaymentConfirmation) {
      setShowPaymentConfirmation(false);
    }
  };

  const handleRemoveScenario = () => {
    setSecondScenario(false);
  };

  return (
    <Container className="p-0 py-12">
      <section className="d-flex justify-content-between align-items-center">
        <h5 className="mb-0">
          {showPaymentConfirmation ? 'Results' : 'Assumptions'}
        </h5>
        <Button
          variant="primary-outline"
          leftIcon={light('circle-plus')}
          onClick={handleAddScenario}
          disabled={secondScenario}
        >
          Add New Scenario
        </Button>
      </section>
      <section className={`'d-flex justify-content-start mt-12`}>
        <NewEstimateComparison
          handleBackToResults={handleBackToResults}
          handleFormsOfPayment={handleFormsOfPayment}
          isInline={isInline}
          handleOnSave={handleOnSave}
          showSecondForm={secondScenario}
          handleRemoveSecondScenario={handleRemoveScenario}
          showPaymentConfirmation={showPaymentConfirmation}
          setShowPaymentConfirmation={setShowPaymentConfirmation}
        />
      </section>
    </Container>
  );
};

export default NewEstimateTab;
